import React, { useContext, useState, useRef, forwardRef, useImperativeHandle } from "react";
import { Toast } from "primereact/toast";

import GlobalContext from "../../../isp._comun/iu/contexto/GlobalContext";
import NotificacionFlotante from "../../../isp._comun/iu/componentes/widgets/notificacionesToast/NotificacionFlotante";
import BarraMenu from "./BarraMenu";
// import { Dropdown } from "primereact/dropdown";
// import ActionNotificarEvento from "../../reductores/ActionNotificarEvento";

const PantallaPrincipalLayout = forwardRef((props, ref) => {
    const { componentesReact } = useContext(GlobalContext);
    // lista_componentes_ventanas = lista_ventanas;
    const toast = useRef(null);

    useImperativeHandle(ref, () => ({
        notificar(notificacionToast) {
            NotificacionFlotante(toast, notificacionToast);
        },
    }));

    return (
        <>
            <BarraMenu />
            {componentesReact}
            <Toast ref={toast} position="bottom-right" />
            {/* <Dropdown
                value={cliente.tipoDeCliente}
                options={tiposCliente}
                onChange={(e) => setCliente({...cliente, tipoDeCliente:e.value})}
                // onChange={cambiarCliente}
                // onClick={enfocar}
                // onMouseDown={enfocar}
                // onFocus={enfocar}
                /* onChange={(e) =>
                setCliente({
                    ...cliente,
                    tipoDeCliente: e.value,
                })
            } 
                // optionLabel="name"
                // placeholder="Selecciona un Tipo"
                //className="p-0 w-full rounded-none"/> 
            */}
        </>
    );
});

export default PantallaPrincipalLayout;
